import { render } from "./PuskesmasComponent.vue?vue&type=template&id=547006f4"
import script from "./PuskesmasComponent.vue?vue&type=script&lang=js"
export * from "./PuskesmasComponent.vue?vue&type=script&lang=js"

import exportComponent from "E:\\WEB-APPS\\gizkia\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__